var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationNoDevices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 159,
    height: 162,
    viewBox: "0 0 159 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-no-devices-a",
    x1: "0%",
    x2: "100%",
    y1: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C1D3DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-no-devices-b",
    x1: "100%",
    x2: "100%",
    y1: "0%",
    y2: "32.136%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5FE504"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E2EBEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-no-devices-c",
    x1: "100%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#9EBBD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#C1D3DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "illustration-no-devices-d",
    x1: "50%",
    x2: "39.674%",
    y1: "10.665%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141,
    height: 133,
    fill: "#C1D3DF",
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E2EBEE",
    d: "M6,0 L34,0 L34,0 L34,133 L6,133 C2.6862915,133 4.05812251e-16,130.313708 0,127 L0,6 C-4.05812251e-16,2.6862915 2.6862915,6.08718376e-16 6,0 Z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69,
    height: 9,
    x: 52,
    y: 15,
    fill: "url(#illustration-no-devices-a)",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-no-devices-b)",
    d: "M22,17.8732836 L22,81.1267164 C22,82.7135871 20.7403225,84 19.1864315,84 L15.8135685,84 C14.2596775,84 13,82.7135871 13,81.1267164 L13,17.8732836 C13,16.2864129 14.2596775,15 15.8135685,15 L19.1864315,15 C20.7403225,15 22,16.2864129 22,17.8732836 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-no-devices-c)",
    d: "M66,41.85 L66,111.15 C66,113.276296 64.8060927,115 63.3333333,115 L54.6666667,115 C53.1939073,115 52,113.276296 52,111.15 L52,41.85 C52,39.7237037 53.1939073,38 54.6666667,38 L63.3333333,38 C64.8060927,38 66,39.7237037 66,41.85 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-no-devices-c)",
    d: "M94,41.85 L94,111.15 C94,113.276296 92.8060927,115 91.3333333,115 L82.6666667,115 C81.1939073,115 80,113.276296 80,111.15 L80,41.85 C80,39.7237037 81.1939073,38 82.6666667,38 L91.3333333,38 C92.8060927,38 94,39.7237037 94,41.85 Z",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-no-devices-c)",
    d: "M121,41.85 L121,111.15 C121,113.276296 119.806093,115 118.333333,115 L109.666667,115 C108.193907,115 107,113.276296 107,111.15 L107,41.85 C107,39.7237037 108.193907,38 109.666667,38 L118.333333,38 C119.806093,38 121,39.7237037 121,41.85 Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillOpacity: 0.274,
    stroke: "#82A4C3",
    strokeWidth: 6,
    d: "M106,66 C113.179702,66 119.679702,68.9101491 124.384776,73.6152237 C129.089851,78.3202983 132,84.8202983 132,92 C132,98.3605824 129.716367,104.187956 125.923406,108.706078 C121.542745,113.92426 115.150713,117.398907 107.93877,117.928821 L107.93877,117.928821 L108.880191,149.970601 C108.888309,150.246624 108.783779,150.499807 108.608213,150.686013 C108.438835,150.865656 108.203341,150.982961 107.939099,150.998297 L107.939099,150.998297 L104.119377,151 C103.852455,151 103.609878,150.895523 103.430597,150.724982 C103.268679,150.570956 103.157498,150.363376 103.127547,150.130165 L103.127547,150.130165 L104.061175,117.928817 C96.8494166,117.398901 90.4575294,113.924402 86.0768881,108.706428 C82.2837514,104.188257 80,98.3607467 80,92 C80,84.8202983 82.9101491,78.3202983 87.6152237,73.6152237 C92.3202983,68.9101491 98.8202983,66 106,66 Z",
    transform: "rotate(-45 106 108.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#illustration-no-devices-d)",
    d: "M95,77 C105.49341,77 114,85.5065898 114,96 C114,102.093407 111.131582,107.516858 106.671368,110.993731 C107.529038,108.828121 108,106.46906 108,104 C108,93.5065898 99.4934102,85 89,85 C84.5999908,85 80.5493088,86.4956479 77.3286198,89.006278 C80.1137838,81.9739447 86.9760284,77 95,77 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationNoDevices);
export default __webpack_public_path__ + "static/media/illustration-no-devices.825d5ddef199ab14ecaad78c95d756c9.svg";
export { ForwardRef as ReactComponent };